import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal, SimpleChanges } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { take } from 'rxjs';
import { CompanyService } from '../../../core/company/company.service';
import { CompanyHubSpot } from '../../../core/hubspot/hubspot';
import { HubSpotService } from '../../../core/hubspot/hubspot.service';

@Component({
  selector: 'app-sync-companies-hubspot',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzFormModule,
    NzListModule,
    NzSelectModule,
    NzPopconfirmModule,
    NzTagModule,
  ],
  templateUrl: './sync-companies-hubspot.component.html',
  styleUrl: './sync-companies-hubspot.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncCompaniesHubspotComponent {
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  companyList = toSignal(this.companyService.itemList$(), { initialValue: [] });

  constructor(
    private messageService: NzMessageService,
    private hubSpotService: HubSpotService,
    private companyService: CompanyService
  ) {}

  companyHubSpotList = signal<{ isAdded: boolean; company: CompanyHubSpot }[]>([]);

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      const chng = changes[propName];

      if (propName === 'isVisible') {
        if (chng.previousValue !== chng.currentValue) {
          if (chng.currentValue) {
            const currentCompanyList = this.companyList();
            this.hubSpotService
              .getCompanyList$()
              .pipe(take(1))
              .subscribe((list: any) => {
                const result = list.results.map((item: any) => {
                  return {
                    isAdded: currentCompanyList.find((c) => c.title === item.properties.name),
                    company: item,
                  };
                });
                this.companyHubSpotList.set(result);
              });
          }
        }
      }
    }
  }

  onIsVisibleChange(event: boolean) {
    this.isVisibleChange.emit(event);
  }

  onCancelClick() {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
  }

  onAddToWorkspaceClick(data: { isAdded: boolean; company: CompanyHubSpot }) {
    data.isAdded = true;
    this.companyService
      .addList$([
        {
          title: data.company.properties.name,
          description: data.company.properties.description,
          unsafeSubData: {
            hubspotCompany: data.company,
          },
        },
      ])
      .pipe(take(1))
      .subscribe(() => {
        this.messageService.success(`Added ${data.company.properties.name} to workspace.`);
      });
  }
}
